// extracted by mini-css-extract-plugin
export const section_wrapper = "articleList-module--section_wrapper--1HQ5S";
export const ternary = "articleList-module--ternary--1SVrt";
export const list_wrapper = "articleList-module--list_wrapper--1XC6M";
export const slider_belowbtn1 = "articleList-module--slider_belowbtn1--1L96l";